import React from 'react';
import { Link } from 'react-router-dom';

const CarInfo = ({ carDetails = {}, ownerLoading = false, ownerDetails = {}, formatDate = (d) => d }) => {
    return (
        <div className="bg-gray-50 rounded-sm border border-gray-200 p-3">
            <h3 className="text-xs font-semibold text-[#2a2e30] mb-2.5 flex items-center">
                <div className="w-2 h-2 bg-[#FF5733] rounded-full mr-2"></div>
                Car Info
            </h3>
            <div className="space-y-1.5 text-xs">
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Plate:</span>
                    <span className="font-medium text-[#2a2e30] xl:text-right">{carDetails.plate_no}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Make:</span>
                    <span className="font-medium text-[#2a2e30] xl:text-right">{carDetails.make}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Model:</span>
                    <span className="font-medium text-[#2a2e30] xl:text-right">{carDetails.model}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Owner:</span>
                    {carDetails.owner_code || carDetails.owner_name ? (
                        <Link
                            to="/owners"
                            className="text-[#FF5733] hover:text-[#e64a2b] transition-colors duration-200 font-medium xl:text-right xl:min-w-0 xl:truncate"
                            title={carDetails.owner_code ? `${carDetails.owner_code}${carDetails.owner_name ? ' - ' + carDetails.owner_name : ''}` : carDetails.owner_name}
                        >
                            {carDetails.owner_code ? `${carDetails.owner_code}${carDetails.owner_name ? ' - ' + carDetails.owner_name : ''}` : carDetails.owner_name}
                        </Link>
                    ) : (
                        <span className="text-gray-400">N/A</span>
                    )}
                </div>
                {/* Owner name is shown inline with Owner link above; avoid duplicate display. */}
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Account Manager:</span>
                    {carDetails.account_manager_name ? (
                        <span className="font-medium text-[#2a2e30] xl:text-right xl:min-w-0 xl:truncate" title={carDetails.account_manager_name}>
                            {carDetails.account_manager_name}
                        </span>
                    ) : (
                        <span className="font-medium text-amber-700 xl:text-right">Unassigned</span>
                    )}
                </div>
                {carDetails.drive_link && (
                    <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                        <span className="text-gray-700 font-medium">Car Drive Folder:</span>
                        <a
                            href={carDetails.drive_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#FF5733] hover:text-[#e64a2b] transition-colors duration-200 font-medium"
                        >
                            Open
                        </a>
                    </div>
                )}
                {/* Created / Updated dates */}
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Created:</span>
                    <span className="font-medium text-[#2a2e30] xl:text-right">{formatDate(carDetails.created_at || carDetails.input_date)}</span>
                </div>
                <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                    <span className="text-gray-700 font-medium">Updated:</span>
                    <span className="font-medium text-[#2a2e30] xl:text-right">{formatDate(carDetails.edit_date || carDetails.updated_at)}</span>
                </div>
            </div>
        </div>
    );
};

export default CarInfo;
